import React from "react";

const ChecklistTitle = ({ title, required, className = "" }) => (
  <div className={`${className} checklist-title`}>
    <h2>
      {title}
      {required && "*"}
    </h2>
  </div>
);

export default ChecklistTitle;
